import { notFound } from 'next/navigation'

const allowedRoutes = [
  '/neumaticos/all',
  '/neumaticos/autos',
  '/neumaticos/camionetas',
  '/neumaticos/industrial',
]

interface Props {
  pathname: string
}

export const checkPaginationRoutes = ({ pathname }: Props) => {
  if (!allowedRoutes.includes(pathname)) {
    notFound()
  }
}
